export default __webpack_public_path__ + "static/media/img3.c2752fc8.jpg";